import React, { useEffect, useState } from "react";
import icons from "../../../assets/images/constantIcons";
import apiService, { formatRupees, handleError } from "../../Common/ApiCommon/ApiService";

const converttime12hrFormat = (timeRange) => {
  if (!timeRange) return "";

  const times = timeRange.split(" - ");
  if (times.length !== 2) return timeRange; // return original if format is incorrect

  const convertTo12Hr = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    const ampm = hours >= 12 ? "PM" : "AM";
    const hour = hours % 12 || 12; // Convert 0 to 12
    return `${hour}:${minutes.toString().padStart(2, "0")} ${ampm}`;
  };

  return `${convertTo12Hr(times[0])} - ${convertTo12Hr(times[1])}`;
}

const ViewTable = ({ isOpen, onClose, tableId }) => {
  const [tableData, setTableData] = useState(null);

  useEffect(() => {
    const fetchTableData = async () => {
      try {
        const response = await apiService.get(`tables/${tableId}`);
        setTableData(response.data);
      } catch (errors) {
        handleError(errors)
      }
    };

    if (tableId) {
      fetchTableData();
    }
  }, [tableId]);

  const TableDetails = [
    { label: "Table Name", value: tableData?.name },
    { label: "Day Charge", value: formatRupees(tableData?.day_charge) },
    { label: "Night Charge", value: formatRupees(tableData?.night_charge) },
    { label: "Day Time", value: converttime12hrFormat(tableData?.day_time_range) },
    { label: "Night Time", value: converttime12hrFormat(tableData?.night_time_range) },
    { label: "Status", value: tableData?.is_active ? "Active" : "Deactive" },
  ]


  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white rounded-lg p-6 w-[90%] max-w-lg h-auto overflow-y-auto relative shadow-lg">
          {/* Close Button */}
          <div
            className="absolute top-4 right-4 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px] flex justify-center items-center"
            onClick={onClose}
          >
            <icons.IoClose className="text-green700 text-xl" />
          </div>
          <h2 className="text-xl font-semibold mb-4 text-gray-700 text-start">
            Table Details
          </h2>

          <div className="overflow-x-auto">
            <table className="category-details-table w-full border-collapse border border-gray-300">
              <thead className="">
                <tr className="bg-green700 text-white">
                  <th className="border p-2  w-1/2">Field</th>
                  <th className="border p-2  w-1/2">Value</th>
                </tr>
              </thead>
              <tbody>
                {TableDetails?.map((value, index) => (
                  <tr key={index}>
                    <td className="border p-2">{value.label}</td>
                    <td className="border p-2">{value.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex justify-end space-x-4 pt-6">
            <button
              type="button"
              onClick={onClose}
              className="py-2 px-4 text-sm bg-white text-green rounded-lg border border-green"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default ViewTable;
